import clsx from "clsx";
import { useEffect } from "react";

import { Button } from "@/components/atoms";
import { useTranslations } from "next-intl";
import type { Sizes } from "../ActionSection/ActionSection";
import styles from "./size-selector.module.css";

function getLabel(name: string) {
  switch (name) {
    case "Small":
      return "S";
    case "Medium":
      return "M";
    case "Large":
      return "L";
    case "X-Large":
      return "XL";
    default:
      return name;
  }
}

const SizeSelector = ({ sizes }: { sizes: Sizes }) => {
  useEffect(() => {
    if (sizes?.sizes?.length === 1 && sizes?.sizes[0].isSelected) return;
    if (sizes?.sizes?.length === 1) {
      sizes.sizes[0].selectSize();
    }
  }, [sizes]);

  const t = useTranslations();

  if (!sizes || !sizes.sizes) return null;
  if (sizes?.sizes?.length === 1) return null;
  return (
    <div className={styles.sizes__container}>
      <div className={styles.sizes__wrapper}>
        <div className={styles.sizes}>
          {sizes?.sizes.map((size) => {
            return (
              <button
                key={`${size.itemId}-size`}
                className={clsx(
                  styles.size,
                  size.isSelected && styles.selected,
                  !size.stock && styles.inactive
                )}
                onClick={size.selectSize}
              >
                {getLabel(size.name)}
              </button>
            );
          })}
        </div>
        <Button className={styles.sizeguide} modal="sizeguide" color="simple">
          {t("productPage.sizeGuideButton")}
        </Button>
      </div>

      {sizes.selectedSize && (
        <p>
          {sizes.selectedSize?.fewLeft && (
            <span className={styles["few-left"]}>
              {t("productPage.fewLeft")}
            </span>
          )}
        </p>
      )}
    </div>
  );
};

export default SizeSelector;
